import { clsx } from 'clsx';
import { FC } from 'react';

interface Props {
  /** Progress should be between 0 and 1 */
  progress: number;
  className?: string;
  label?: string;
}

export const ProgressBar: FC<Props> = ({ progress, className, label }) => (
  <div
    className={clsx('relative block h-1 w-full overflow-hidden rounded-2xs bg-for-neu-tie3', className)}
    role="progressbar"
    aria-label={label}
    aria-valuenow={progress}
    aria-valuemin={0}
    aria-valuemax={1}
  >
    <div
      className="300ms h-1 w-full rounded-2xs bg-for-suc-bas transition-transform ease-out"
      style={{ transform: `translateX(${-100 + progress * 100}%)` }}
    />
  </div>
);
